module.exports = __webpack_public_path__ + "img/Lich.240f20e2.png";